import * as types from "./types";

export function fetchActivityLogsStart(startDate, endDate) {
  return {
    type: types.FETCH_ACTIVITY_LOGS_START,
    startDate,
    endDate
  };
}

export function fetchActivityLogsSuccess(logs) {
  return {
    type: types.FETCH_ACTIVITY_LOGS_SUCCESS,
    logs
  };
}
